import { Anchor, Box, Container, Flex, Text } from '@mantine/core';
import dayjs from 'dayjs';
import type { FC } from 'react';

import { env } from '../../../env.ts';
import { Logo } from '../Logo/Logo.tsx';

export const Footer: FC = () => {
  return (
    <Box bg="#1D1D1D" pos="relative" w="100%">
      <Container size="lg">
        <Flex py="lg">
          <Logo color="white" />
        </Flex>
      </Container>
      <Box style={{ borderTop: '1px solid  #3E3E3E' }} w="100%">
        <Container size="lg">
          <Flex align="center" justify="space-between" py="xs">
            <Text c="#F4F4F4" size="xxs">
              GoGigi © {dayjs().year()}
            </Text>
            {!__IS_PRODUCTION__ && (
              <Text c="#F4F4F4" size="xxs">
                {__APP_VERSION__}
              </Text>
            )}
            <Anchor
              c="#F4F4F4"
              // /terms-of-service is the route on the Qwik frontend, which is what gogigi.com
              // serves today (/info/terms 404s there). frontend-tanstack uses /info/terms, so
              // this has to move when that replaces it.
              href={env.VITE_FRONTEND_URL ? `${env.VITE_FRONTEND_URL}/terms-of-service` : undefined}
              rel="noopener noreferrer"
              size="xxs"
              target="_blank"
            >
              Terms and conditions
            </Anchor>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
};
